import { useEffect, useRef, useCallback } from "react";
import Pusher from "pusher-js";
import { generateBaseUri } from "utils/helper";
import { createChannelAuthorization } from "utils/pusherAuth";

// Mengaktifkan log pusher untuk debugging
// Pusher.logToConsole = true;

const initializePusher = () => {
  const pusher = new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
    forceTLS: true,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    // Token diambil saat auth (selalu terbaru); X-App: wa ikut dari default customAxios
    channelAuthorization: createChannelAuthorization(
      `${generateBaseUri()}/WA/broadcasting/auth`
    ),
  });

  return pusher;
};

export const usePusher = (channelName) => {
  const pusherRef = useRef(null);
  const channelRef = useRef(null);

  useEffect(() => {
    const pusher = initializePusher();
    pusherRef.current = pusher;

    if (channelName) {
      const channel = pusher.subscribe(channelName);
      channelRef.current = channel;
    }

    // Cleanup function to unsubscribe and disconnect on unmount
    return () => {
      if (channelRef.current) {
        pusher.unsubscribe(channelName);
      }
      if (pusherRef.current) {
        pusher.disconnect();
      }
    };
  }, [channelName]);

  const reconnectPusher = useCallback(() => {
    if (pusherRef.current) {
      pusherRef.current.disconnect(); // Memutuskan koneksi Pusher
      // Auth channel otomatis pakai token terbaru (lihat createChannelAuthorization)
      pusherRef.current.connect();
    }
  }, []);

  return { channelRef, pusherRef, reconnectPusher };
};

export default initializePusher;
